import { handleActions } from 'redux-actions'
import types from '../actions/types'

export const defaultState = null

export default handleActions({
	[types.VOTE_READ]: (state, action) => action.payload,
}, defaultState)



// WEBPACK FOOTER //
// ./src/redux/reducers/vote.js